import { render, staticRenderFns } from "./dy-add-customer-shop.vue?vue&type=template&id=249b177a&scoped=true&"
import script from "./dy-add-customer-shop.vue?vue&type=script&lang=js&"
export * from "./dy-add-customer-shop.vue?vue&type=script&lang=js&"
import style0 from "./dy-add-customer-shop.vue?vue&type=style&index=0&id=249b177a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249b177a",
  null
  
)

export default component.exports